<template>
  <div class="modal-mask">
    <section class="modal reduced">
      <div class="content">
        <h1>{{parData.title}}</h1>
      </div>
      <hr>
      <div class="content">
        <div class="spacer-10"></div>
        <p class="pStrong pSpace">{{parData.description}}</p>
      </div>
      <div class="spacer-10"></div>
      <hr>
      <div class="content">
        <button  class="redButton" @click="continueProcess">{{parData.proceedButton}}</button>
        <a @click="$emit('close')">{{parData.cancel}}</a>
      </div>
      <div class='spacer-10'></div>

    </section>
  </div>
</template>

<script>
export default {
  props: ["parData"],
  data() {
    return {};
  },
  methods: {
    continueProcess() {
      this.$emit("continueprocess", this.parData);
      this.$emit("close");
    }
  }
};
</script>